import { render, staticRenderFns } from "./PerformanceHeader.vue?vue&type=template&id=0e617197&scoped=true"
import script from "./PerformanceHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PerformanceHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PerformanceHeader.vue?vue&type=style&index=0&id=0e617197&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e617197",
  null
  
)

export default component.exports